import { render, staticRenderFns } from "./nav-item.vue?vue&type=template&id=2f96e61d&scoped=true&"
import script from "./nav-item.vue?vue&type=script&lang=js&"
export * from "./nav-item.vue?vue&type=script&lang=js&"
import style0 from "./nav-item.vue?vue&type=style&index=0&id=2f96e61d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96e61d",
  null
  
)

export default component.exports